document.addEventListener("DOMContentLoaded", () => {
  const commentForm = document.getElementById('commentform');
  const commentsBlock = document.querySelector('.wp-block-cp2-custom-comments');
  
  if (!commentForm || !commentsBlock) return;

  const authorField = commentForm.querySelector('.comment-form-author input#author');
  const emailField = commentForm.querySelector('.comment-form-email input#email');
  const urlField = commentForm.querySelector('.comment-form-url input#url');
  const commentTextArea = commentForm.querySelector('#comment');
  const submitButton = commentForm.querySelector('#submit');
  
  // Get AJAX data from the block
  const postId = commentsBlock.dataset.postId;
  const ajaxUrl = commentsBlock.dataset.ajaxUrl;
  const nonce = commentsBlock.dataset.nonce;
  const maxDepth = parseInt(commentsBlock.dataset.maxDepth || '3', 10);
  
  // Track current parent comment ID for replies
  let currentParentId = 0;
  
  // Also reference WP's hidden fields if present
  const commentParentField = commentForm.querySelector('#comment_parent');

  // Inject spinner styles once
  (function injectSpinnerStyles() {
    if (document.getElementById('cp-comment-spinner-styles')) return;
    const style = document.createElement('style');
    style.id = 'cp-comment-spinner-styles';
    style.textContent = `
      @keyframes cp-spin { to { transform: rotate(360deg); } }
      .cp-comment-spinner { display: inline-block; width: 16px; height: 16px; border: 2px solid rgba(0,0,0,0.2); border-top-color: rgba(0,0,0,0.6); border-radius: 50%; animation: cp-spin 0.8s linear infinite; margin-left: 8px; vertical-align: middle; }
      .cp-comment-btn-loading[aria-busy="true"] { opacity: 0.8; }
    `;
    document.head.appendChild(style);
  })();

  // Hide name/email/URL by default (for logged-out users)
  if (authorField) authorField.parentElement.style.display = 'none';
  if (emailField) emailField.parentElement.style.display = 'none';
  if (urlField) urlField.parentElement.style.display = 'none';

  // Show them when the comment box is focused
  commentTextArea.addEventListener('focus', () => {
    if (authorField) authorField.parentElement.style.display = 'block';
    if (emailField) emailField.parentElement.style.display = 'block';
    if (urlField) urlField.parentElement.style.display = 'block';
  });

  // Validate fields and update button state
  function validateFields() {
    let valid = true;

    // For logged-out users, name and email are required:
    if (authorField && authorField.value.trim() === '') valid = false;
    if (emailField && emailField.value.trim() === '') valid = false;

    // Comment field is always required
    if (!commentTextArea || commentTextArea.value.trim() === '') {
      valid = false;
    }

    // Basic email check
    if (emailField && emailField.value && !emailField.value.includes('@')) {
      valid = false;
    }

    // Enable/disable the button
    submitButton.disabled = !valid;

    // Add/remove a "disabled" style class
    submitButton.classList.toggle('disable-comment-btn', !valid);
  }

  // Initialize the button as disabled + class applied
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.classList.add('disable-comment-btn');
  }

  // Listen for any input changes
  [authorField, emailField, commentTextArea].forEach(field => {
    if (field) field.addEventListener('input', validateFields);
  });

  /**
   * Load comments via AJAX
   */
  function loadComments() {
    const commentsContainer = document.getElementById('comments-container');
    const loadingIndicator = document.getElementById('comments-loading');
    
    if (!commentsContainer) return;
    
    const formData = new FormData();
    formData.append('action', 'get_comments');
    formData.append('post_id', postId);
    formData.append('nonce', nonce);
    
    fetch(ajaxUrl, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // Hide loading indicator
        if (loadingIndicator) {
          loadingIndicator.style.display = 'none';
        }
        
        // Update comments container
        commentsContainer.innerHTML = data.data.comments_html;
        
        // Update comment count
        updateCommentCount(data.data.comments_count);
        
        // Apply comment count fixes to any new elements
        fixCommentCountStyle();
        
        // Set up reply link handlers for the loaded comments
        handleReplyClicks();
        
        // Also log the HTML content to see what we got
        console.log('Comments HTML loaded:', commentsContainer.innerHTML.substring(0, 500) + '...');
      } else {
        console.error('Failed to load comments:', data.data);
        if (loadingIndicator) {
          loadingIndicator.innerHTML = '<div style="color: #999;">Unable to load comments</div>';
        }
      }
    })
    .catch(error => {
      console.error('Error loading comments:', error);
      if (loadingIndicator) {
        loadingIndicator.innerHTML = '<div style="color: #999;">Unable to load comments</div>';
      }
    });
  }

  /**
   * Submit comment via AJAX
   */
  function submitCommentAjax(event) {
    event.preventDefault();
    
    if (submitButton.disabled) return;
    
    // Show loading state
    const isInput = submitButton.tagName && submitButton.tagName.toLowerCase() === 'input';
    const originalLabel = isInput ? submitButton.value : submitButton.innerHTML;
    submitButton.classList.add('cp-comment-btn-loading');
    submitButton.setAttribute('aria-busy', 'true');
    submitButton.disabled = true;

    // Add spinner and status text without replacing layout entirely
    let spinner = document.querySelector('.cp-comment-spinner');
    if (!spinner) {
      spinner = document.createElement('span');
      spinner.className = 'cp-comment-spinner';
    }

    if (isInput) {
      // Update visible value for inputs and place spinner after the input
      submitButton.value = 'Submitting…';
      if (!submitButton.nextElementSibling || !submitButton.nextElementSibling.classList.contains('cp-comment-spinner')) {
        submitButton.insertAdjacentElement('afterend', spinner);
      }
    } else {
      // For button elements, append status text and spinner inside the button
      if (!submitButton.querySelector('.cp-comment-status-text')) {
        const status = document.createElement('span');
        status.className = 'cp-comment-status-text';
        status.style.marginLeft = '8px';
        status.textContent = 'Submitting…';
        submitButton.appendChild(status);
      }
      if (!submitButton.querySelector('.cp-comment-spinner')) {
        submitButton.appendChild(spinner);
      }
    }
    
    // Determine parent being submitted right now (source of truth)
    const effectiveParentId = commentParentField && commentParentField.value ? parseInt(commentParentField.value, 10) : currentParentId;
    const submittedParentId = isNaN(effectiveParentId) ? 0 : effectiveParentId;

    const formData = new FormData();
    formData.append('action', 'submit_comment');
    formData.append('post_id', postId);
    formData.append('nonce', nonce);
    formData.append('comment', commentTextArea.value);
    
    // Prefer WP hidden field value (set by comment-reply.js) over our local state
    formData.append('comment_parent', submittedParentId);
    
    console.log('Submitting comment with currentParentId:', currentParentId); // Debug logging
    
    
    // Add author info for non-logged-in users
    if (authorField) formData.append('author', authorField.value);
    if (emailField) formData.append('email', emailField.value);
    if (urlField) formData.append('url', urlField.value);
    
    fetch(ajaxUrl, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // Clear the form
        commentTextArea.value = '';
        if (authorField) authorField.value = '';
        if (emailField) emailField.value = '';
        if (urlField) urlField.value = '';
        
        // Hide the author fields again
        if (authorField) authorField.parentElement.style.display = 'none';
        if (emailField) emailField.parentElement.style.display = 'none';
        if (urlField) urlField.parentElement.style.display = 'none';
        
        // Reset form validation state
        validateFields();
        
        // Check if this was a reply before resetting state
        const wasReply = submittedParentId > 0;
        
        // Reset reply state back to new comment mode
        resetReplyState();
        
        // Handle different comment statuses
        if (data.data.status === 'approved') {
          // For replies, reload all comments to ensure proper threading
          if (wasReply) {
            loadComments();
            showMessage('Reply submitted successfully!', 'success');
          } else {
            // This was a new top-level comment - add it normally
            addNewCommentToList(data.data.comment_html);
            showMessage('Comment submitted successfully!', 'success');
          }
        } else if (data.data.status === 'pending') {
          // Comment is pending moderation
          showMessage(data.data.message || 'Your comment is awaiting moderation and will appear once approved.', 'info');
        } else {
          // Unknown status
          showMessage('Comment submitted, but status is unclear. Please refresh to see if it appears.', 'info');
        }
        
        // After any DOM update, enforce depth rules again
        enforceMaxDepth();
        
      } else {
        showMessage('Error: ' + data.data, 'error');
      }
    })
    .catch(error => {
      console.error('Error submitting comment:', error);
      showMessage('Failed to submit comment. Please try again.', 'error');
    })
    .finally(() => {
      // Reset button state
      submitButton.classList.remove('cp-comment-btn-loading');
      submitButton.removeAttribute('aria-busy');
      submitButton.disabled = false;

      if (isInput) {
        submitButton.value = originalLabel;
        if (submitButton.nextElementSibling && submitButton.nextElementSibling.classList.contains('cp-comment-spinner')) {
          submitButton.nextElementSibling.remove();
        }
      } else {
        const status = submitButton.querySelector('.cp-comment-status-text');
        if (status) status.remove();
        const sp = submitButton.querySelector('.cp-comment-spinner');
        if (sp) sp.remove();
      }

      validateFields(); // Re-validate to set correct disabled state
    });
  }

  /**
   * Add new comment to the comments list
   */
  function addNewCommentToList(commentHtml) {
    const commentsContainer = document.getElementById('comments-container');
    if (!commentsContainer) return;
    
    let commentsList = commentsContainer.querySelector('.comment-list');
    
    // Create comments list if it doesn't exist
    if (!commentsList) {
      commentsList = document.createElement('ol');
      commentsList.className = 'comment-list';
      commentsContainer.appendChild(commentsList);
    }
    
    // Add the new comment
    commentsList.insertAdjacentHTML('beforeend', commentHtml);
    
    // Update comment count
    const currentCount = commentsList.children.length;
    updateCommentCount(currentCount);
    
    // Apply styling fixes to new comment
    fixCommentCountStyle();
    
    // Set up reply handlers for the new comment
    handleReplyClicks();
    
    // Enforce max depth again
    enforceMaxDepth();
  }

  /**
   * Update the comment count display
   */
  function updateCommentCount(count) {
    const commentCountElement = document.querySelector('.comment-count');
    if (commentCountElement) {
      commentCountElement.textContent = `(${count})`;
    }
  }

  /**
   * Show temporary message to user
   */
  function showMessage(message, type = 'info', isReply = false) {
    // Remove any existing messages of the same type
    const existingMessage = document.querySelector('.ajax-comment-message');
    if (existingMessage && !isReply) {
      existingMessage.remove();
    }
    
    const messageDiv = document.createElement('div');
    messageDiv.className = 'ajax-comment-message';
    if (isReply) {
      messageDiv.setAttribute('data-reply', 'true');
      messageDiv.style.cursor = 'pointer';
    }
    messageDiv.style.cssText = `
      padding: 10px;
      margin: 10px 0;
      border-radius: 4px;
      ${type === 'success' ? 'background: #d4edda; color: #155724; border: 1px solid #c3e6cb;' : 
        type === 'error' ? 'background: #f8d7da; color: #721c24; border: 1px solid #f5c6cb;' : 
        'background: #d1ecf1; color: #0c5460; border: 1px solid #bee5eb;'}
      ${isReply ? 'cursor: pointer;' : ''}
    `;
    messageDiv.textContent = message;
    
    // Add click handler for reply cancel
    if (isReply) {
      messageDiv.addEventListener('click', resetReplyState);
    }
    
    // Insert message before the comment form
    commentForm.parentNode.insertBefore(messageDiv, commentForm);
    
    // Auto-remove after 8 seconds for reply messages, 5 for others
    setTimeout(() => {
      if (messageDiv.parentNode) {
        messageDiv.remove();
      }
    }, isReply ? 8000 : 5000);
  }

  /**
   * Handle reply link clicks
   */
  function handleReplyClicks() {
    // Before wiring clicks, hide reply links beyond allowed depth
    enforceMaxDepth();

    const replyLinks = document.querySelectorAll('a.comment-reply-link');
    
    console.log('Found reply links:', replyLinks.length); // Debug logging
    
    replyLinks.forEach((link, index) => {
      console.log(`Reply link ${index}:`, link.getAttribute('href'));
      link.addEventListener('click', function() {
        setTimeout(() => {
          const pid = commentParentField && commentParentField.value ? parseInt(commentParentField.value, 10) : 0;
          currentParentId = isNaN(pid) ? 0 : pid;
          console.log('Detected currentParentId from #comment_parent:', currentParentId);
          if (currentParentId > 0) {
            commentTextArea.placeholder = 'Write a reply...';
            commentTextArea.focus();
            commentTextArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (authorField) authorField.parentElement.style.display = 'block';
            if (emailField) emailField.parentElement.style.display = 'block';
            if (urlField) urlField.parentElement.style.display = 'block';
            showMessage(`Replying to comment #${currentParentId}. Click here to cancel reply.`, 'info', true);
          }
        }, 0);
      });
    });
  }

  // Hide/disable reply links at or beyond max depth
  function enforceMaxDepth() {
    const listItems = document.querySelectorAll('#comments-container li[id^="comment-"]');
    listItems.forEach(li => {
      const depthClasses = Array.from(li.classList).filter(c => c.indexOf('depth-') === 0);
      let depth = 1;
      if (depthClasses.length) {
        const m = depthClasses[0].match(/depth-(\d+)/);
        if (m) depth = parseInt(m[1], 10) || 1;
      }
      if (depth >= maxDepth) {
        const reply = li.querySelector('a.comment-reply-link');
        if (reply) {
          reply.style.display = 'none';
          reply.setAttribute('aria-hidden', 'true');
          reply.setAttribute('tabindex', '-1');
        }
      }
    });
  }

  /**
   * Reset reply state back to new comment
   */
  function resetReplyState() {
    currentParentId = 0;
    if (commentParentField) commentParentField.value = '0';
    commentTextArea.placeholder = 'Write a comment...';
    
    // Hide author fields again for logged-out users (unless they're focused)
    if (authorField && document.activeElement !== commentTextArea) {
      authorField.parentElement.style.display = 'none';
    }
    if (emailField && document.activeElement !== commentTextArea) {
      emailField.parentElement.style.display = 'none';
    }
    if (urlField && document.activeElement !== commentTextArea) {
      urlField.parentElement.style.display = 'none';
    }
    
    // Remove any reply message
    const replyMessage = document.querySelector('.ajax-comment-message[data-reply="true"]');
    if (replyMessage) {
      replyMessage.remove();
    }
  }

  // Load comments on page load
  loadComments();

  // Handle form submission via AJAX
  commentForm.addEventListener('submit', submitCommentAjax);
  
  // Handle reply functionality after comments are loaded
  // We'll call this after each comment load/update

  // Fix for comment count circular styling
  function fixCommentCountStyle() {
    const commentCounts = document.querySelectorAll('.comment-count');
    commentCounts.forEach(count => {
      // Force inline display and remove any potential circular styling
      count.style.display = 'inline';
      count.style.background = 'transparent';
      count.style.border = 'none';
      count.style.borderRadius = '0';
      count.style.width = 'auto';
      count.style.height = 'auto';
      count.style.minWidth = '0';
      count.style.minHeight = '0';
    });
  }

  // Fix immediately
  fixCommentCountStyle();

  // Fix after a slight delay to override any potential post-load styling
  setTimeout(fixCommentCountStyle, 100);

  // Also use MutationObserver to keep fixing any dynamically added comment counts
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        fixCommentCountStyle();
      }
    }
  });

  // Start observing the document for any changes
  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'] 
  });
});
